export default __webpack_public_path__ + "static/media/icons8-pass-fail-100.47a0dd45.svg";